const features = [
  {
    icon: 'ri-hammer-line',
    title: 'Quality Craftsmanship',
    description: 'Meticulous attention to detail in every project we undertake'
  },
  {
    icon: 'ri-time-line',
    title: 'On-Time Delivery',
    description: 'Reliable scheduling and commitment to project deadlines'
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Licensed & Insured',
    description: 'Fully certified and protected for your peace of mind'
  },
  {
    icon: 'ri-chat-3-line',
    title: 'Clear Communication',
    description: 'Transparent updates throughout your project journey'
  }
];

export default function WhyChooseUs() {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Image */}
          <div className="relative rounded-r-3xl overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/fc44fbc616cd1ecb663bd7b11885401b.jpg"
              alt="Our Professional Framing Team"
              className="w-full h-full object-cover object-top shadow-2xl"
            />
            <div className="absolute inset-0 ring-2 ring-brand/50 rounded-r-3xl"></div>
          </div>

          {/* Right Column - Content */}
          <div className="text-white">
            <div className="mb-4">
              <span className="text-brand text-sm font-semibold uppercase tracking-wider">
                Why All Phases Builders
              </span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">
              Your Trusted Construction Partner
            </h2>
            <p className="text-gray-300 text-lg leading-relaxed mb-10">
              With decades of experience and hundreds of successful projects, we've built our reputation on delivering exceptional results. Our commitment to quality, transparency, and customer satisfaction sets us apart in the construction industry.
            </p>

            {/* Features Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-white/5 border border-white/10 rounded-xl p-6 hover:border-brand transition-all cursor-pointer group"
                >
                  <div className="w-10 h-10 flex items-center justify-center mb-4">
                    <i className={`${feature.icon} text-3xl text-brand group-hover:scale-110 transition-transform`}></i>
                  </div>
                  <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>

            {/* CTA Button */}
            <button
              onClick={scrollToContact}
              className="bg-brand text-white px-10 py-4 rounded-xl font-semibold hover:bg-brand-dark transition-all hover:scale-105 whitespace-nowrap"
            >
              Schedule Consultation
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
